import { render } from "./weeklyRankRewardsRoom.vue?vue&type=template&id=2ea74a7e"
import script from "./weeklyRankRewardsRoom.vue?vue&type=script&lang=js"
export * from "./weeklyRankRewardsRoom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__